import { render, staticRenderFns } from "./AffirmBrowseBook.vue?vue&type=template&id=5fab891d&"
import script from "./AffirmBrowseBook.vue?vue&type=script&lang=js&"
export * from "./AffirmBrowseBook.vue?vue&type=script&lang=js&"
import style0 from "./AffirmBrowseBook.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports